import { Dto } from '@core/data/dto/dto';
import { DtoExport, DtoForceConstructor, DtoImport } from '@core/utils/dto';
import { Address } from '../../common/address';
import { Entity } from '@core/data/dto/entity';
import { WorkplaceSchema } from './workplace.schema';
import { copyObjectProperties } from '@core/utils/object';
import { DTO_DEFAULT, DtoType } from '@core/data/dto/dto-types';

export class Workplace implements Entity {
    public id: string;
    public name: string;
    public address: Address;
    public primary: boolean;

    constructor(value?: any) {
        if (value) {
            copyObjectProperties.call(this, value);
        }
    }

    @DtoImport(WorkplaceSchema)
    static import(dto: Dto): any {
        return new Workplace(dto);
    }

    @DtoExport([
        {
            type: DTO_DEFAULT,
            dto: WorkplaceSchema,
        },
    ])
    export(type?: DtoType): any {}
}
